<script>
    import appConfig from "../../../app.config";
    import "swiper/swiper-bundle.css";
    import axios from 'axios';
    export default {
        page: {
            title: "Starter",
            meta: [{
                name: "description",
                content: appConfig.description
            }],
        },
        data() {
            return {
                title: "Starter",
                items: [{
                        text: "Pages",
                        href: "/",
                    },
                    {
                        text: "Starter",
                        active: true,
                    },
                ],
                status:'',
                redirect_url:'',
                orderfor:'',
            };
        },

        methods: {
            getDetail(){
                axios.get(process.env.VUE_APP_API_BASEURL+'customer/create/'+this.$route.params.id+'/'+this.$route.params.hash)
                .then(response => {
                    console.log(response.data);
                    if (response) {
                        if(response.data.status=='error'){
                            this.messageBag = response.data.msj;
                        }
                        else{
                            this.detail = response.data;                           
                            this.redirect_url = this.detail.redirect_url;  
                            this.orderfor = this.detail.orderfor;
                            if( this.detail.orderfor == 'DLCSH03' || this.detail.orderfor == 'DLCSH04'){
                                //do nothing
                            }else{
                                this.redirectURL(this.redirect_url);
                            }
                        }
                    } 
                    else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.OrderSeen = false;
                });
            },

            redirectURL(redirect_url){
                setTimeout(function(){ window.location = redirect_url; },6000);
            }
        },

        components: {
            // lottie: Lottie
        },
        mounted(){
            this.getDetail();
            //setTimeout(function(){ window.location = "https://portal.renewplus.my/portal/index.php"; },6000);
        }
    };
</script>

<style >
    #container{
        padding-top:20px;
        margin-top:0px;
        /*width:100vw;*/
        color:#ffffff;
        background-color:#184232;
        display:flex;
        flex-direction:column;
        font-family: "Montserrat", sans-serif;
        font-size: 15px;
        bottom:0;
    }
    #contacts{
        display:flex;
        justify-content:space-around;
        align-items:center;
        width:100%;
    }
    #footer{
        display:flex;
        justify-content:space-around;
        width:100%;
    }
    #contact{
        font-weight: 900;
    }
    #contacts--contact{
        text-align:right;
    }
   
    #mentions p {
        font-size:0.5em;
    }
    .card {
    margin-bottom: -9.5rem !important;
    }
    .container-fluid{
        padding-right: 0px !important;
        padding-left: 0px !important;
    }
 
    @media (min-width: 1025px) and (max-width: 2399px){
           
        .progress-nav .progress {
            position: absolute;
            left: -86%;
            top: 54%;
            width: 173%;
            transform: rotate(90deg);
            /* background-color: #77BF4C !important;*/
        }
    }

    @media (min-width: 2400px) and (max-width: 3399px){
           
           .progress-nav .progress {
            position: absolute;
            left: -42.5%;
            top: 60%;
            width: 85%;
            transform: rotate(90deg);
            /* background-color: #77BF4C !important;*/
           }
       }

    .fixed-top {
        background-color: #FFFFFF !important;
    }
    .navbar {
        padding-top: 0px !important;
    /* padding-bottom: 0px !important; */
    }

    .btn {
        color: #fff;
        background-color: #77BF4C !important;
        border-color: #77BF4C !important;
    }

    .coming-soon-text {
        font-weight: 600;
        text-transform: uppercase;
        color: #326d21;
        text-shadow: 3px 4px #67b173;

    }

    .auth-page-content{
        background-color:#FFFFFF;
    }
  
</style>

<template>
    <div class="layout-wrapper landing">

        <nav class="navbar navbar-expand-lg fixed-top" id="navbar">
            <div class="container-fluid"  v-if="orderfor =='DLC-eCOMM'">
                <div class="ms-5"> 
                    <a class="navbar-brand" href="">
                        <img style="width: 150px" src="https://shop.compasia.com/cdn/shop/files/logo_150x@2x.png" class="img-fluid card-logo card-logo-dark pt-3" alt="logo dark" >
                        <img src="https://renewp.compasia.com/assets/images/logo.png" class="card-logo card-logo-light" alt="logo light" >
                    </a>
                </div>
      
                <div class="collapse navbar-collapse " id="navbarNavDropdown">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a class="nav-link invisible" href="#">Features</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link invisible" href="#">Features</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link invisible" href="#">Features</a>
                        </li>
                        <li class="nav-item">
                            <span class="fw-bold fs-2">CompAsia Instalment Plan</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="container-fluid"  v-if="orderfor =='DLCCA2'">
                <div class="ms-5"> 
                    <a class="navbar-brand" href="">
                        <img style="width: 150px" src="https://shop.compasia.com/cdn/shop/files/logo_150x@2x.png" class="img-fluid card-logo card-logo-dark pt-3" alt="logo dark" >
                        <img src="https://renewp.compasia.com/assets/images/logo.png" class="card-logo card-logo-light" alt="logo light" >
                    </a>
                </div>
      
                <div class="collapse navbar-collapse " id="navbarNavDropdown">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a class="nav-link invisible" href="#">Features</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link invisible" href="#">Features</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link invisible" href="#">Features</a>
                        </li>
                        <li class="nav-item">
                            <span class="fw-bold fs-2">ReNewNGo</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="container" v-else>
                <a class="navbar-brand" href="">
                    <img style="width: 95px" src="https://renewp.compasia.com/assets/images/logo.png" class="img-fluid card-logo card-logo-dark" alt="logo dark" >
                    <img src="https://renewp.compasia.com/assets/images/logo.png" class="card-logo card-logo-light" alt="logo light" >
                </a>
            </div>
        </nav>

        <section class="section pb-0 hero-section" id="hero" >
        <!-- start hero section -->
            <div class="auth-page-content pt-5 pb-5">
                <div class="container pt-5 pb-5">
                    <div class="row pt-5">
                        <div class="col-lg-12">
                            <div class="text-center mt-sm-5 pt-4">
                            <div class="mb-5 text-black-50">
                                <img :src="'https://d3hqyhmwxbyxgr.cloudfront.net/products/97240-success.gif'" style="width: 150px"/> 
                                <h1 class="display-5 coming-soon-text">
                                APPLICATION SAVED!
                                </h1>
                                <br>
                                <p class="fs-15">An email containing steps on how to continue has been sent to you.</p>
                                <div class="mt-4 pt-2" v-if="orderfor == 'DLCSH03' || orderfor == 'DLCSH04'">
                                </div>
                                <div class="mt-4 pt-2" v-else>
                                <a :href="redirect_url" class="btn btn-success"><i class="mdi mdi-home me-1"></i> Back to Home</a>
                                </div>
                            </div>

                            </div>
                        </div>
                    </div>
                    <!-- end row -->
                </div>
            <!-- end container -->
            </div>    
            <div id="container" class="">
                <div v-if="orderfor =='DLC-eCOMM' || orderfor =='DLCCA2'">
                    <div id="footer">
                        <div>
                            <span id="contact">Contact</span>
                            <p></p>
                            <div>CompAsia Sdn Bhd - 1006653-T (Online Store)</div>
                            <div>Suite 2.02, Wisma Academy,</div>
                            <div>No. 4 Jalan 19/1, Seksyen 19,</div>
                            <div>46300 Petaling Jaya, Selangor.</div>
                        </div>
                        <div>
                            <span id="contact">About</span>
                            <p></p>
                            <div><a style="color: white;" href="https://shop.compasia.com/pages/about-us">About Us</a></div>                        
                        </div>                    
                        <div id="copyright" class="ms-5"> 
                            <!-- <span>&copy; {{ new Date().getFullYear()  }} CompAsia e-Store</span> -->
                
                        </div>
                    </div>
                </div>
                <div class="container pb-4" v-else>
                 
                    <div class="row justify-content-left">
                        <div class="col-12">
                            <div>{{ new Date().getFullYear()  }} &copy; CompAsia</div>
                        </div>
                        <!--div class="col-4 text-center">
                            Design & Develop by Compasia IT
                        </div-->
                    </div>
                </div>
            </div>
        </section>
    </div>
    
</template>